import { LoadUtils } from "funkis-foundation";
import _ from "lodash";

const PAGE_ITEM_ID_VALUES_REVEALED = "8518176C-FF02-4173";
const PAGE_ITEM_ID_START_REVEALED = "3E07D4C3-C36B-4F81";
const PAGE_ITEM_ID_COMPLETE_REVEALED = "7EFCC27C-93C6-4030";
const PAGE_ITEM_ID_VIEW_VIDEO = "0502E9DE-1B79-4463-84D9-9119F41F8108";
const PAGE_ITEM_ID_VIDEO = "0502E9DE-1B79-4463";
const SPRIG_TARGET_DATA_KEY = "E0AEE8C7-711F-4504-BE3E-89C31CE9B32F";

export const GA_EVENT = {
	BEGIN_QUIZ: "begin_quiz",
	COMPLETE_QUIZ: "complete_quiz",
	SELECT_LANGUAGE: "select_language",
	ADD_CUSTOM_WORD: "add_custom_word",
	SELECT_VALUES: "select_values",
	SUBMIT_ANSWER: "submit_answer",
	LEARN_MORE: "learn_more",
	SAVE_RESULTS: "save_results",
	SHARE_RESULTS: "share_results",
	VIDEO: "video",
};

let firedEvents: Array<{ eventName: string; params: object }> = [];

const loadSprig = async () => {
	const sprigPath = "content/json/sst_story_dinner-with-friends-v1.json";
	const textPath = "content/language/en-global/cmt_text_en-global.json";

	let sprigs;
	let texts;

	try {
		sprigs = await LoadUtils.loadJSON(sprigPath);
	} catch (error) {
		//
	}

	try {
		texts = await LoadUtils.loadJSON(textPath);
	} catch (error) {
		//
	}

	return { sprigs, texts };
};

let sprigs;
let texts;

loadSprig()
	.then((result) => {
		sprigs = result.sprigs;
		texts = result.texts;
	})
	.catch((e) => {
		debugger;
	});

const analyticsMiddleware = (store) => (next) => (action) => {
	// console.log("dispatching", action);
	if (isAnalyticsReady()) {
		// If analytics ready...
		// Get and send sprig data...
		if (action.type === "UPDATE_QUID_INPUT") {
			switch (action?.item?.quidType) {
				case "sprigStory":
					// Event: CUSTOM_WORD
					const selectedTraits = action.item.data.selectedTraits;
					let customWords: Array<string> =
						(selectedTraits && selectedTraits.map((item) => item.name_text)) ||
						[];
					customWords = customWords.filter((item) => item !== undefined);
					console.log("customWords.length", customWords.length);
					if (customWords.length) {
						sendAnalyticsEvent(
							GA_EVENT.ADD_CUSTOM_WORD,
							{
								customWord: customWords.pop(),
							},
							false,
							true
						);
						break;
					}
					// Event: SUBMIT_ANSWER
					const selectedSprigs = action.item.data.selectedSprigs;
					if (!selectedSprigs) {
						break;
					}
					const exitId = selectedSprigs[selectedSprigs.length - 1].exitId;
					const sprigId = selectedSprigs[selectedSprigs.length - 1].sprigId;
					const sprig = sprigs.find((item) => item.id === sprigId);
					const exit = sprig.exits.find((item) => item.id === exitId);
					const exitIndex = sprig.exits.findIndex((item) => item.id === exitId);
					const sprigTitle = texts.find(
						(item) => item.id === sprig.txt_title_id
					);

					sendAnalyticsEvent(
						GA_EVENT.SUBMIT_ANSWER,
						{
							questionText: sprigTitle.value,
							questionIndex: selectedSprigs.length,
							answerText: exit.text_string,
							answer: exitIndex,
						},
						false,
						true
					);

					break;

				default:
					break;
			}
		}

		if (action.type === "UPDATE_APP_DATA_VALUE") {
			// Event: VIDEO (play)
			if (action?.item?.currently_paying_video === PAGE_ITEM_ID_VIEW_VIDEO) {
				sendAnalyticsEvent(
					GA_EVENT.VIDEO,
					{ action: "play", fileName: "ikea_key_values.mp4" },
					true
				);
			}
		}
		if (action.type === "UPDATE_PAGE_ITEM") {
			// Event: VIDEO (completed)
			if (
				action?.item?.id === PAGE_ITEM_ID_VIDEO &&
				action?.item?.status === "completed"
			) {
				sendAnalyticsEvent(GA_EVENT.VIDEO, {
					action: "progress",
					progress: 100,
					fileName: "ikea_key_values.mp4",
				});
			}
			// Event: BEGIN_QUIZ
			else if (
				action?.item?.id === PAGE_ITEM_ID_START_REVEALED &&
				action?.item?.revealed
			) {
				sendAnalyticsEvent(GA_EVENT.BEGIN_QUIZ, {}, true);
			}
			// Event: COMPLETE_QUIZ
			else if (
				action?.item?.id === PAGE_ITEM_ID_COMPLETE_REVEALED &&
				action?.item?.revealed
			) {
				sendAnalyticsEvent(GA_EVENT.COMPLETE_QUIZ, {}, true);
			}
			// Event: SELECT_VALUES
			else if (
				action?.item?.id === PAGE_ITEM_ID_VALUES_REVEALED &&
				action?.item?.revealed
			) {
				const quidInputs = store.getState()["quidInputs"].items;
				const quidinput = quidInputs.find(
					(item) => item.targetDataKey === SPRIG_TARGET_DATA_KEY
				);
				const selectedTraits = quidinput.data.selectedTraits;
				const selectedValues = selectedTraits.map(
					(trait) => trait.friendly_id || trait.name_text
				);
				sendAnalyticsEvent(GA_EVENT.SELECT_VALUES, {
					questionText: "Select the words that reflect your personal values.",
					selectedValues,
				});
			}
		}
		if (action.type === "UPDATE_CONFIG") {
			// Event: SELECT_LANGUAGE
			if (action.item.language) {
				sendAnalyticsEvent(GA_EVENT.SELECT_LANGUAGE, {
					languageCode: action.item.language,
				});
			}
		}
		if (action.type === "UPDATE_PAGE" && action.item?.status === "incomplete") {
			// Event: UPDATE_PAGE
			const pagesById = store.getState()["pages"].itemsById;
			const page = pagesById[action.item.id];
			if (page?.data?.cmtPage?.type !== "page") {
				// stop events from language menu, splash, and other "not real" pages
				return;
			}
			sendAnalyticsEvent(GA_EVENT.LEARN_MORE, {
				value: page.friendlyId,
			});
		}
	}

	let result = next(action);
	return result;
};

const isAnalyticsReady = () => {
	return (
		sprigs &&
		texts &&
		window["appReady"] &&
		(window["v"] ?? window.parent["gtag"])
	);
};

export const sendAnalyticsEvent = (
	eventName: string,
	params: object = {},
	once = false, // Send event by the eventname to analytics one
	uniq = false // Send then event by the same params once
) => {
	const gtag = window["v"] ?? window.parent["gtag"];
	const gaLegacy = window["ga"] && window["ga"].getAll()[0];
	if (gtag || gaLegacy) {
		// IKEA.com tracking constants and tweaks
		const actionName = "Link click";
		params = params || {};
		params["event_category"] = "Me&IKEA";
		params["event_label"] = eventName; // begin_quiz, learn_more, submit_answer, etc.

		const shouldAddQuestionNumberToEventLabel = !!(
			params["event_label"] === "submit_answer" && params["questionIndex"]
		);
		if (shouldAddQuestionNumberToEventLabel) {
			params["event_label"] += `_${params["questionIndex"]}`; // submit_answer_1, submit_answer_2, etc.
		}

		if (
			(!once ||
				(once && !firedEvents.find((item) => item.eventName === eventName))) &&
			(!uniq ||
				(uniq && !firedEvents.find((item) => _.isEqual(item.params, params))))
		) {
			console.log(
				`Attempting to send analytics with Event: ${eventName} and params: ${JSON.stringify(
					params
				)}`
			);

			// IKEA.com tweak: favor gtag over gaLegacy
			if (gtag) {
				// GA4
				// gtag api: https://developers.google.com/tag-platform/gtagjs/reference
				gtag("event", actionName, params);
			} else if (gaLegacy) {
				// UA (GA3)
				// GA3 send api: https://developers.google.com/analytics/devguides/collection/analyticsjs/events#implementation
				gaLegacy.send(
					"event",
					params["event_category"],
					actionName,
					params["event_label"]
				);
			} else {
				debugger;
			}

			firedEvents.push({ eventName, params });
		}
	}
};

export default analyticsMiddleware;
